import i18n from 'i18next'
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import dk from './dk'
import en from './en'
import fi from './fi'
import fr from './fr'
import nb from './nb'
import sv from './sv'

const fallbackLanguage = 'en'

export function setup(overrideLng?: string) {
  i18n
    .use(I18nextBrowserLanguageDetector)
    .use(initReactI18next)
    .init({
      resources: {
        en: { common: en },
        nb: { common: nb },
        dk: { common: dk },
        da: { common: dk }, // Used for tracking
        sv: { common: sv },
        fi: { common: fi },
        fr: { common: fr }
      },
      lng: overrideLng,
      fallbackLng: fallbackLanguage,
      debug: false,
      defaultNS: 'translation',
      fallbackNS: 'common',
      returnNull: false,
      interpolation: {
        escapeValue: false, // not needed for react
        formatSeparator: ',',
        skipOnVariables: false
      },
      react: {
        useSuspense: false,
        bindI18n: 'languageChanged loaded',
        bindI18nStore: 'added removed',
        nsMode: 'default'
      }
    })
}
export { tUnchecked } from './tUnchecked'
